import { z } from 'zod';

export const buildInstanceDetailSchema = (
    displayNameRequired: string,
    capacityGroupIdInvalid: string,
) =>
    z.object({
        subscriptionName: z.string().trim().min(1, { message: displayNameRequired }).max(255),
        comment: z.string().max(2000),
        salesforceLink: z.string().max(255),
        customerName: z.string().max(255),
        companyName: z.string().max(255),
        capacityGroupId: z.union([
            z.string().trim().uuid({ message: capacityGroupIdInvalid }),
            z.literal(''),
        ]),
        capacityGroupName: z.string().max(255),
    });

export type InstanceDetailFormValues = z.infer<ReturnType<typeof buildInstanceDetailSchema>>;
